
import Setup from "./Setup";
import Global from './Global'
export default {
  ...Setup,
...Global


};

